/* eslint-disable jsx-a11y/alt-text */
import s from "./Rate.module.css";

import { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { getFullSetting } from "@store/slices/sliceSettings";

import coin from "@assets/images/coin.svg"


const Rate = () => {
  const [course, setCourse] = useState({ cf_donat: 0, cf_donat_max: 0 });

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {settings : {info}} = useSelector((state) => state.settings);

  useEffect(() => {
    dispatch(getFullSetting());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useMemo(() => {
    setCourse({ cf_donat: info.cf_donat, cf_donat_max: info.cf_donat_max });
  }, [info]);

  let discountStatus = course.cf_donat >= course.cf_donat_max;

  return (
    <div className={discountStatus ? s.courseRub + ' ' + s.discountClass : s.courseRub}>
      <div className={s.header}>
        <span className={s.icon}><img src={coin} /></span>
        <span>{t("Donat.valute")}</span>
      </div>

      <div className={s.main}>1 RUB - <span>{(Number(course.cf_donat)).toLocaleString('ru-RU')}</span> B-Coin</div>
    </div>
  );
};

export default Rate;
